import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Carousel from '../Carousel/Carousel';
import { imagesWithText } from '../Home Page/HomePage';

import { TransportAdmi } from './TransportAdminContext';

const LoginFormTransportAdmin = () => {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { TransportAdminDetails, updateTransportAdminDetails } = TransportAdmi();
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(''); // Reset any previous error messages
    
        try {
            const response = await fetch('https://zoomautos.co.uk/api/moveadmin/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
    
            const data = await response.json();
    
            if (response.ok) {
                console.log('User authenticated', data);
    
                localStorage.setItem('TransportData', JSON.stringify(data.admin));
                sessionStorage.setItem('Transport Admin AuthToken', data.token);
                console.log("Siuu",localStorage.getItem('Transport Admin AuthToken'));
    
                updateTransportAdminDetails(data.admin); // Update context
                alert(JSON.stringify(data.admin)); // Alert admin details directly
    
                setFormData({ username: '', password: '' }); // Reset form
                navigate('/Logistics/Admin/AdminPortal');
            } else {
                setError(data.message || 'Invalid credentials');
            }
        } catch (error) {
            console.error('Error during authentication:', error);
            setError('An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <>
            {/* Add blur effect back for production */}
            <Carousel imagesWithText={imagesWithText} style={{ filter: 'blur(5px)' }} />

            <div className="portallogin">
                <div className="heading">Sign In</div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            required
                            className="input"
                            type="text"
                            name="username"
                            id="username"
                            placeholder="Username"
                            value={formData.username}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            required
                            className="input"
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Password"
                            value={formData.password}
                            onChange={handleChange}
                        />
                    </div>
                    <input
                        className="contact-button"
                        type="submit"
                        value={loading ? 'Signing In...' : 'Sign In'}
                        disabled={loading}
                    />
                </form>

                {error && <p className="error-message">{error}</p>}
            </div>
        </>
    );
};

export default LoginFormTransportAdmin;
